import { ScannerStatus } from '../interfaces/Scanner';

export enum SearchStatus {
  Loading = 10,
  Error,
}
export type ScannerComponentStatus = ScannerStatus | SearchStatus;
